<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    this.$nextTick(() => {

      // let maxWidth = window.innerWidth
      // let maxHeight = window.innerHeight
      // if(maxWidth/1920*1080 > maxHeight) {
      //   document.getElementsByClassName('hello')[0].style.transform = `scale(${maxHeight/1080})`
      //   document.getElementById('app').style.width = 1920*maxHeight/1080 + 'px'
      // }else {
      //   document.getElementById('app').style.transform = `scale(${maxWidth/1920})`
      // }
    })
  }
}
</script>

<style>
html body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  /* background: rgba(10, 19, 65, 1); */
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* width: 1920px;
  height: 1080px; */
  /* overflow: hidden; */
  margin: 0 auto;
}
</style>
